import Joi from '@hapi/joi'

export const LeafCollectionOverviewSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Factory cannot have invalid characters`,
        "any.required": `Factory required`
    }),
    startDate: Joi.string().invalid("").label("Start Date"),
   // endDate: Joi.string().invalid("").label("End Date")
}